import { render, staticRenderFns } from "./parts2.vue?vue&type=template&id=1171d0b0&scoped=true&"
import script from "./parts2.vue?vue&type=script&lang=ts&"
export * from "./parts2.vue?vue&type=script&lang=ts&"
import style0 from "./parts2.vue?vue&type=style&index=0&id=1171d0b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171d0b0",
  null
  
)

export default component.exports